// ignore-string-externalization

import { track } from '@spotify-internal/track-js';
import { isWebView } from '../../../features/src/isWebView';

/**
 * Sets up tracking with Google Tag Manager and OneTrust cookie consent management.
 *
 * This function configures the tracking infrastructure required for GDPR compliance
 * and analytics tracking. It uses @spotify-internal/track-js to manage the integration
 * between OneTrust (cookie consent), Google Tag Manager (analytics), and Optimize.
 *
 * Key Features:
 * - OneTrust cookie banner for GDPR compliance in EU/EEA countries
 * - Google Tag Manager (GTM) for analytics and tag management
 * - Domain-specific tracking (only on *.spotify.com domains)
 * - Exclusion of webview environments and synthetic tests
 * - Automatic consent management via "OptanonConsent" cookie
 *
 * How it works:
 * 1. track-js loads container scripts (OneTrust, GTM, Optimize) in correct order
 * 2. OneTrust stores consent in window.dataLayer for GTM to access
 * 3. GTM controls which tags/scripts to load based on user consent
 * 4. "OptanonConsent" cookie encodes user's cookie preferences
 *
 * For more information about cookie banners and consent management at Spotify:
 * @see https://backstage.spotify.net/docs/default/component/client-web/cookie-banners
 *
 * Support: Contact #cmp_integration_web on Slack for OneTrust/GTM configuration issues
 *
 * @returns void
 */
export function setupTracking(): void {
  if (!isWebView()) {
    track({
      market: 'not_set',
      googleTagManagerId:
        process.env.NODE_ENV === 'production' ? 'GTM-NP2G964' : undefined,
      oneTrust:
        // ignore cookie banner in synthetic tests for now
        !navigator.webdriver &&
        // cookie is only set on *.spotify.com
        window.location.host.endsWith('.spotify.com'),
    });
  }
}
